var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.532,11.46l-3.532-3.454-3.535,3.458c-.945.944-1.465,2.2-1.465,3.536s.52,2.591,1.465,3.536c.944.944,2.2,1.464,3.535,1.464s2.591-.52,3.536-1.464c1.95-1.95,1.95-5.122-.004-7.075Zm-.703,6.368c-1.512,1.511-4.146,1.511-5.657,0-.756-.755-1.172-1.76-1.172-2.829s.416-2.073,1.168-2.825l2.832-2.77,2.829,2.766c1.56,1.56,1.56,4.098,0,5.657Zm-10.829,5.171c-2.206,0-4-1.794-4-4v-10h8.124l.876-.857V1h2V0H2v1h2v18c0,2.757,2.243,5,5,5,2.014,0,3.743-1.203,4.534-2.923-.291-.166-.57-.353-.836-.562-.599,1.456-2.029,2.485-3.698,2.485ZM13,1v7H5V1h8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTests);
export default __webpack_public_path__ + "static/media/tests.11ce7f5ed2c8161f17f10f6e1a01cf06.svg";
export { ForwardRef as ReactComponent };